import { useEffect, useRef, useState } from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import css from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';
import { useRouter } from 'next/router';
import EcoVideo from 'eco-design/base/eco-video';

const Roof: React.FC = () => {
    const { t } = useLang('shp3');
    const { isPad, isH5 } = useDeviceDetect();
    const [video, setVideo] = useState('');
    const { locale = '' } = useRouter();
    /** 动画 */
    const infoRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const label = infoRef.current?.querySelector('.label');
        const title = infoRef.current?.querySelector('.title');
        const desc = infoRef.current?.querySelector('.desc');
        const video = document?.querySelector('.shp3-E .eco-video');
        const ani1 = AniContainer.create({
            triggerElement: infoRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                label?.classList.add('enter');
                title?.classList.add('enter');
                desc?.classList.add('enter');
                video?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    label?.classList.remove('enter');
                    title?.classList.remove('enter');
                    desc?.classList.remove('enter');
                    video?.classList.remove('enter');
                }
            },
        });

        const ani2 = AniContainer.create({
            triggerElement: '.shp3-C',
            triggerHook: 1,
            onEnter: () => setVideo('https://websiteoss.ecoflow.com/upload/video/1760095758922/01_Ready_1.mp4'),
        });
        return () => {
            ani1.destroy?.();
            ani2.destroy?.();
        };
    }, []);

    return (
        <>
            <EcoSpace />
            <section className={`${css.section} shp3-E GtmModuleData-section`} id="shp3-E" data-section-id={'shp3-E'} data-section-title={t('title')}>
                <div className="info" ref={infoRef}>
                    <div className="left">
                        <div className="label ani-1">{t('E_label')}</div>
                        <div className="title ani-2">{t('E_title')}</div>
                    </div>
                    <div className="desc right ani-2-5">
                        {t.rich('E_desc', {
                            h: (a: string) => {
                                return <span className="white">{a}</span>;
                            },
                        })}
                    </div>
                </div>

                <div className="eco-video ani-3">
                    <div className="video">
                        {video && (
                            <video
                                // className="video"
                                src={video}
                                autoPlay
                                loop
                                muted
                                preload="metadata"
                                poster="https://websiteoss.ecoflow.com/upload/image/1754397510191/4-pc.jpg"
                                width="100%"
                                height="100%"
                                playsInline
                                aria-label={t('E_title')}
                            />
                        )}
                        <img
                            className="sub-img"
                            src={
                                isPad || isH5
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1760180047781/m_%E9%A3%8E%E6%9A%B4%E9%80%9A%E7%9F%A5.jpg'
                                    : 'https://websiteoss.ecoflow.com/upload/image/1760179178167/pc_%E9%A3%8E%E6%9A%B4%E9%80%9A%E7%9F%A5.jpg'
                            }
                            loading="lazy"
                            draggable="false"
                        />
                    </div>
                </div>
                {locale === 'us' && <p className="footer">{t('E_footer')}</p>}
            </section>
        </>
    );
};

export default Roof;
